<template>
    <div class="list-metal">
        <div class="text-right mb-3">
            <b-button class="btn btn-info mr-1 btn-sm" @click="showFilter" v-if="role != 9">Filter</b-button>
        </div>
        <filter-table-deposit v-if="isShowFilter" @setDataFilter="setDataFilterToParent" :dataClient="[]" :dataContract="dataContract"></filter-table-deposit>
        <table>
            <thead>
                <tr id="top">
                    <th scope="col" style="width: 70px">No</th>
                    <th scope="col">Serial Number</th>
                    <th scope="col">Year</th>
                    <th scope="col" style="width: 120px">owner</th>
                    <th scope="col">Hallmark</th>
                    <th scope="col">Fineness</th>
                    <th scope="col">Denom (gr)</th>
                    <th scope="col" style="width: 200px">Deposite Date</th>
                    <th scope="col" style="width: 120px" v-if="typeDeposit == 'offexchange'">Deposit Due Date</th>
                </tr>
            </thead>
            <tbody v-if="isLoadingData">
                <tr>
                    <td colspan="10">
                        <b-spinner></b-spinner>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="(data, i) in metalData" :key="i" v-show="metalData.length != 0">
                    <td data-label="No">{{ (pageNumber - 1) * totalPerPage + (i + 1) }}</td>
                    <td data-label="Serial Number">{{ data.serial_number }}</td>
                    <td data-label="Year">{{ data.year }}</td>
                    <td data-label="Owner">{{ data.owner }}</td>
                    <td data-label="Hallmark">{{ data.hallmark }}</td>
                    <td data-label="Fineness">{{ data.fineness }}</td>
                    <td data-label="Weight">{{ data.weight }}</td>
                    <td data-label="Deposite Date">{{ data.metal_date | formatDate }}</td>
                    <td data-label="Deposite Due Date" v-if="typeDeposit == 'offexchange'">{{ data.due_date | formatDate }}</td>
                </tr>
                <tr v-show="metalData.length == 0">
                    <td colspan="10">No Data Available in Table</td>
                </tr>
            </tbody>
        </table>
        <b-modal ref="offexchange" hide-footer title="Add Deposit">
            <div class="d-block">
                <form action="">
                    <div class="form-group">
                        <label for="" class="label-client"> Choose Client</label>
                        <select name="" id="" class="form-input" v-model="clientSelected">
                            <option value="" selected disabled>Choose Client</option>
                            <option v-for="(client, i) in listVendors" :key="i" :value="{ id: client._id, owner: client.company_name }">
                                {{ client.company_name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="">Code Exchanger</label>
                        <select name="" id="" v-model="form.codeexc" class="form-input">
                            <option value="" disabled selected>Choose Code Exchanger</option>
                            <option v-for="(code, i) in dataExchanger" :key="i" :value="code.codeexc">{{ code.nameexc }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Metal Type</label>
                        <select class="form-input" v-model="form.metal_form">
                            <option value="cast">Cast</option>
                            <option value="mint">Mint</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Deposite Date</label>
                        <input type="date" v-model="form.deposite_date" placeholder="deposite date" :max="today" class="form-input" />
                    </div>
                    <div class="form-group">
                        <label>Fineness</label>
                        <input type="text" v-model="form.fineness" class="form-input" />
                    </div>
                    <div class="form-group">
                        <label>Hallmark</label>
                        <input type="text" v-model="form.hallmark" class="form-input" />
                    </div>
                    <div class="form-group">
                        <label>Weight (gr)</label>
                        <input type="text" v-model="form.weight" class="form-input" />
                    </div>
                    <div class="form-group">
                        <label>Serial Number</label>
                        <input type="text" v-model="form.serial_number" class="form-input" />
                    </div>
                    <div class="form-group">
                        <label>Year</label>
                        <input type="text" v-model="form.year" class="form-input" />
                    </div>
                </form>
            </div>

            <div class="text-right">
                <b-button class="mt-3" variant="primary" @click="addDeposite" :disabled="!clientSelected">
                    <span v-if="!isLoading">Submit</span>
                    <b-spinner small v-else></b-spinner>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import FilterTableDeposit from "../utility/filter/FilterTableDeposit.vue";
export default {
    components: { FilterTableDeposit },
    props: {
        metalData: Array,
        pageNumber: Number,
        totalPerPage: Number,
        listVendors: Array,
        dataExchanger: Array,
        dataContract: Array,
        dataClient: Array,
        isLoadingData: Boolean,
        totalData: Number,
        typeDeposit: {
            type: String,
            default: "onexchange",
        },
    },
    data() {
        return {
            role: sessionStorage.getItem("role"),
            isLoading: false,
            isShowFilter: false,
            clientSelected: {
                id: "",
                owner: "",
            },
            form: {
                info: "",
                vendor_id: "",
                codeexc: "",
                owner: "",
                metal_type: "gold",
                metal_form: "",
                deposite_date: "",
                fineness: "",
                hallmark: "",
                weight: Number(),
                serial_number: "",
                year: Number(),
            },
            today: "",
            activity: "deposit",
            owner: "",
            startDate: "",
            endDate: "",
            serial_number: "",
            hallmark: "",
            status: "",
            date_type: "",
            perPage: 10,
            currentPage: 1,
            contract_id: "",
        };
    },
    mounted() {
        this.today = new Date().toISOString().split("T")[0];
        // axios.get("/v2/clearing/admin/abx/get/list_depositor?type=offexchange").then((res) => {
        //     this.dataClient = res.data.data.body;
        // });
    },
    methods: {
        showModal(modalRef) {
            this.$refs[modalRef].show();
        },
        showFilter() {
            this.isShowFilter = !this.isShowFilter;
            this.$emit("setShowFilter", this.isShowFilter);
        },
        setDataFilterToParent(event) {
            this.$emit("setFilterTable", event);
        },
        addDeposite() {
            this.form.vendor_id = this.clientSelected;
            this.isLoading = true;
            this.$store.dispatch("getLocation").then((resGeo) => {
                if (resGeo.cityData[0]) {
                    this.form.info = JSON.stringify(resGeo);
                } else {
                    let data = resGeo;
                    data.newLatLong = resGeo.cityLatLong.split(",");
                    this.form.info = JSON.stringify(data);
                }
                const dataAddDeposit = {
                    info: this.form.info,
                    vendor_id: this.clientSelected.id,
                    codeexc: this.form.codeexc,
                    owner: this.clientSelected.owner,
                    metal_type: this.form.metal_type,
                    metal_form: this.form.metal_form,
                    deposite_date: this.form.deposite_date,
                    fineness: this.form.fineness,
                    hallmark: this.form.hallmark,
                    weight: this.form.weight,
                    serial_number: this.form.serial_number,
                    year: this.form.year,
                };
                axios.post("/v2/clearing/admin/abx/offexchange/deposit/add", dataAddDeposit).then((res) => {
                    if (!res.data.iserror) {
                        this.$toast.success("Add Deposit Success");
                        this.isLoading = false;
                        setTimeout(() => {
                            location.reload();
                        }, 2000);
                    }
                });
            });
        },
    },
};
</script>

<style scoped>
.form-group label {
    width: 30%;
}

.form-input {
    width: 70%;
    border-radius: 5px;
    border: 1px solid #454545;
    padding: 5px 0.5rem;
    font-size: 13px;
}
</style>
